import React from 'react';

export const TsuLocationNameModal = {
  title: 'Source Location Name',
  body: (
    <div>
      <p>
        The Country, State, Province or Island where the tsunami source occurred (For example enter: Japan or Honshu)
      </p>
      <p>
        This is only an approximate geographic location. Events prior to 1900 were not instrumentally located, therefore, the location given is based on the latitude and longitude of the city where the maximum effects occurred. If there are different spellings of a city name the additional names are in parentheses.
      </p>
    </div>
  ),
};
